/**
 * used for the project horizontal scroll navigation
 */
export default (() => {

  const init = () => {
    const projectNavBtns = document.querySelectorAll(".js-horizontal-scroll");

    if (projectNavBtns === null) {
      return;
    }

    projectNavBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        const scrollTo = btn.getAttribute("data-scroll-to");
        window.scrollTo({
          left: scrollTo,
          behavior: 'smooth'
        });
      });
    })
  }

  return {
    init
  }
})()
